module.exports = __webpack_public_path__ + "img/12-istanbul.1dcfac08.png";